// Shared composer behaviors (fn-48.5) — lifted out of `ChatComposer`
// so `<StartConversation>`'s message field shares the SAME load-bearing
// keydown + autosize logic without inheriting the chat composer's
// gate-shaped props, placeholder, or labels.
//
// The IME guard is the part that must never fork: an IME composition
// commit (`isComposing`, or legacy keyCode 229 — some browsers report
// it after compositionend) must insert text, never send.
/** Autosize a textarea to its content (CSS max-height caps it). */
export function autosizeTextArea(el) {
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
}
/**
 * True when a keydown should SEND: plain Enter, not Shift+Enter, and
 * not an IME composition commit. Callers `preventDefault()` and run
 * their submit guard when this returns true.
 */
export function isComposerSendKey(e) {
    if (e.key !== 'Enter' || e.shiftKey)
        return false;
    // IME guard: a composition commit must insert, never send.
    if (e.nativeEvent.isComposing || e.keyCode === 229)
        return false;
    return true;
}
//# sourceMappingURL=composer-behaviors.js.map